import { SignUp as ExternalSignUp } from '@rockstar/registration-component'
import type { TLang } from 'src/constants/langs'

import BgMobile from 'src/icons/BG-mobile-modal.webp'

export const SignUp = ({ language }: { language: TLang }) => {
    const bgImg = BgMobile

    return <ExternalSignUp language={language} backgroundImage={bgImg} />
}
